import { z } from 'zod';

export const InfobarPayload = z.object({
  enabled: z.boolean().optional(),
  iconUrl: z.string().optional(),
  message: z.string(),
});
export type InfobarPayload = z.infer<typeof InfobarPayload>;

export const HeroBannerPayload = z.object({
  enabled: z.boolean().optional(),
  imageUrl: z.string(),
  mobileImageUrl: z.string().optional(),
  redirectUrl: z.string().optional(),
});
export type HeroBannerPayload = z.infer<typeof HeroBannerPayload>;

export const SupportBarPayload = z.object({
  au: z.object({
    enabled: z.boolean().optional(),
    message: z.string().optional(),
    title: z.string().optional(),
  }),
  nz: z.object({
    enabled: z.boolean().optional(),
    message: z.string().optional(),
    title: z.string().optional(),
  }),
});
export type SupportBarPayload = z.infer<typeof SupportBarPayload>;

export const HubPersonalization = z.object({
  infobar: InfobarPayload.nullable().optional(),
  heroBanner: HeroBannerPayload.nullable().optional(),
  supportBar: SupportBarPayload.nullable().optional(),
});
export type HubPersonalization = z.infer<typeof HubPersonalization>;
